import { Link } from "react-router-dom"

import type { DiagnosticsIndexViewProps } from "@/domains/diagnostics/types"
import { Card } from "@/components/card"

export const DiagnosticsIndexView = ({ cards }: DiagnosticsIndexViewProps) => {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
      {cards.map((card) => (
        <Link key={card.href} to={card.href}>
          <Card.Container className="cursor-pointer transition-all hover:border-p300-light hover:bg-p400-light">
            <div className="flex flex-col gap-2">
              <h3 className="text-lg font-semibold text-t100">{card.title}</h3>
              <p className="text-sm text-t200">{card.description}</p>
            </div>
          </Card.Container>
        </Link>
      ))}
    </div>
  )
}
